<template>
  <v-container
    v-touch="{
      left: () => $refs.smTable.changeActiveDate(1),
      right: () => $refs.smTable.changeActiveDate(-1),
      down: () => getCurrentAttendanceAndLeave()
    }"
    class="pa-0 max-width-md"
  >
    <v-card
      v-if="attendancesWithLeaves"
      flat
      tile
      class="pa-3"
    >
      <v-toolbar
        flat
      >
        <v-toolbar-title>
          {{ $t('Attendance.Title') }}
        </v-toolbar-title>
      </v-toolbar>

      <S-Attendance-Table-Sm
        ref="smTable"
        :attendances="attendancesWithLeaves"
        class="d-md-none"
      />

      <S-Attendance-Table-Lg
        :attendances="attendancesWithLeaves"
        class="d-none d-md-block"
      />

      <div
        v-if="attendancesWithLeaves && attendancesWithLeaves.length > 0"
        class="float-right mt-2 grey--text d-none d-md-block"
      >
        {{ $t('Attendance.LastCalculationTime') }}：{{ lastCalculationTime }}
      </div>

      <v-sheet
        v-if="attendancesWithLeaves && attendancesWithLeaves.length > 0"
        color="yellow lighten-2"
        class="d-block d-sm-inline-block py-3 px-5 mt-3"
      >
        <span class="text-subtitle-2">{{ $t('Attendance.PreviousWeekAccumulate') }}:</span> {{ previousPeriodBalance }}<br>
        <span class="text-subtitle-2">{{ $t('Attendance.TotalTime') }}*:</span> {{ adjustmentPeriodSettlmentAmount }}
      </v-sheet>

      <div class="d-block d-md-flex">
        <div class="mt-2">
          <v-btn
            v-if="$config.isWeb"
            color="primary"
            :href="hrAttendanceAbjUrl"
          >
            {{ $t('Attendance.AdjustWorkingTime') }}
          </v-btn>
        </div>

        <v-spacer />

        <div class="mt-2 d-flex">
          <v-btn
            depressed
            class="mr-3"
            @click="getCurrentAttendanceAndLeave"
          >
            {{ $t('PublicServant.AmendAttendance.ThisWeek') }}
          </v-btn>

          <v-spacer class="d-md-none" />

          <v-btn
            depressed
            class="mr-3"
            @click="getPreWeekRecords"
          >
            <v-icon>{{ mdiChevronLeft }}</v-icon>
          </v-btn>

          <v-btn
            depressed
            @click="getNextWeekRecords"
          >
            <v-icon>{{ mdiChevronRight }}</v-icon>
          </v-btn>
        </div>
      </div>

      <br><br>

      <div class="text-caption">
        *{{ $t('Attendance.Adjust.Notice') }}
      </div>
    </v-card>
  </v-container>
</template>

<script>

// import SAttendanceTable from './components/SAttendanceTable'
import { secondToHourMinute, momentWithHyphen } from '@/utils/datetimeUtil'
import { mapState } from 'vuex'
import SAttendanceTableSm from './components/SAttendanceTableSm'
import SAttendanceTableLg from './components/SAttendanceTableLg'
import siteIntegrate from '@/api/general/siteIntegrate'
import { attendanceModule } from '../../store/moduleName'
import attendance from '../../store/modules/attendance/attendance'
import store from '../../store'
import { Touch } from 'vuetify/lib/directives'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'

// import { isFieldBlank } from '../utils/stringUtil'
if (!store.state[attendanceModule]) store.registerModule(attendanceModule, attendance)

export default {
  directives: {
    Touch
  },
  components: {
    // SAttendanceTable,
    SAttendanceTableSm,
    SAttendanceTableLg
  },
  data: function () {
    return {
      hrAttendanceAbjUrl: siteIntegrate.getHrAttendanceAbjUrl(),
      mdiChevronLeft: mdiChevronLeft,
      mdiChevronRight: mdiChevronRight
      // currentDate: null
    }
  },
  computed: {
    ...mapState(attendanceModule, {
      attendancesWithLeaves: state => state.attendancesWithLeaves
    }),
    lastCalculationTime: function () {
      return momentWithHyphen(this.attendancesWithLeaves[6].lastCalculationTime).format('YYYY-MM-DD HH:mm')
    },
    previousPeriodBalance: function () {
      if (this.attendancesWithLeaves[6].previousPeriodBalance) {
        return secondToHourMinute(this.attendancesWithLeaves[6].previousPeriodBalance, 'xh xm')
      } else {
        return '--'
      }
    },
    adjustmentPeriodSettlmentAmount: function () {
      if (this.attendancesWithLeaves[6].adjustmentPeriodSettlmentAmount) {
        return secondToHourMinute(this.attendancesWithLeaves[6].adjustmentPeriodSettlmentAmount, 'xh xm')
      } else {
        return '--'
      }
    }
  },
  async created () {
    this.getCurrentAttendanceAndLeave()
  },
  methods: {
    getPreWeekRecords () {
      this.$store.dispatch(attendanceModule + '/getPreWeekRecords')
    },

    getNextWeekRecords () {
      this.$store.dispatch(attendanceModule + '/getNextWeekRecords')
    },
    async getCurrentAttendanceAndLeave () {
      await this.$store.dispatch(attendanceModule + '/getCurrentDate')
      this.$store.dispatch(attendanceModule + '/getAttendanceAndLeave')
    }
  }
}
</script>
